import React from 'react'
import './contact.css'

const Contact = () => {
  return (
    <div className='contact section__padding' id='contact'>
      <div className="contact-heading">
        <h1>Elérhetőség</h1>
      </div>
      <div className="contact-container">
        <p>9999 Város, UtcaNév utca. 100.</p>
        <p>E-mail: woodmaster@ifo.com</p>
        <p>@2022 JudyProject <br/> All rights reserved.</p>
      </div>
      
    </div>
  )
}

export default Contact